import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import { RedTimes, TableView } from '~/stylizations/styles';
import Strong from '~/components/Strong';

export default function CardView({ visible, onClose, card, isMobile }) {
  const { t } = useTranslation();

  const label = (text) => <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t(text)}</span>;
  const child = (text) => {
    if (text == null || text == '') {
      return <RedTimes />;
    }

    return <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{t(text)}</span>;
  };

  const childMobile = [
    {
      title: label('Operadores'),
      dataIndex: 'summary',
      key: 'summary',
      render: (text, record) => (
        <div>
          <Strong>{t('Tipo de cartão')}:</Strong> {record.card_type_name}
          <br />
          <Strong>{t('screens:Juros')}:</Strong> {record.fee}
          <br />
        </div>
      ),
    },
  ];

  return (
    <Modal
      title={`${t('Informações')} - ${card?.name ?? ''}`}
      open={visible}
      onCancel={onClose}
      centered
      width={isMobile ? '100%' : '1200px'}
      footer={<ModalFooter showOk={false} onCancel={onClose} />}
    >
      <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={[{ title: label('Nome'), dataIndex: 'name', render: child }]}
        dataSource={[card] || []}
      />
      <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={
          isMobile
            ? childMobile
            : [
                { title: label('Tipo de cartão'), dataIndex: 'card_type_name', render: child },
                { title: label('Juros'), dataIndex: 'fee', render: child },
              ]
        }
        dataSource={card?.cards}
      />
    </Modal>
  );
}
